import { render, staticRenderFns } from "./LaundryActivity.vue?vue&type=template&id=9f501d70"
import script from "./LaundryActivity.vue?vue&type=script&lang=js"
export * from "./LaundryActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports